import { SearchResult } from 'app/concierge/types';
import { Box, Stack } from '@mui/material';
import IconMi from 'components/common/icon/IconMi';
import React, { useMemo } from 'react';
import { ICustomStyles } from 'app/concierge/panel';
import defaultStyles from '../styles';
import { useSelector } from 'react-redux';
import { merge } from 'lodash';

export default function SimpleResultItem({
    result,
    onItemClick,
}: {
    result: SearchResult;
    onItemClick: (result: SearchResult) => void;
}) {
    const customStyles = useSelector((state: any) => state.concierge.customStyles) as ICustomStyles;

    const styles = useMemo(() => {
        return merge({}, defaultStyles, customStyles?.activeChatMessageResultItem) as typeof defaultStyles;
    }, [customStyles]);

    const getIcon = (type: string) => {
        switch (type) {
            case 'portal_page':
                return 'portal-pages';
            case 'notification_schedule_distribution':
                return 'burst';
            case 'dataset':
                return 'datasets';
            case 'dataset_data':
                return 'datasets';
            case 'document':
                return 'documents';
            default:
                return 'metric';
        }
    };

    const description = result.description ?? null;

    return (
        <Stack sx={styles.item} key={result.id}>
            <Stack direction={'row'} spacing={1}>
                <Box>
                    <IconMi icon={getIcon(result.type)} fontSize="16" />
                </Box>
                <Box sx={styles.link} onClick={() => onItemClick(result)}>
                    {result.name}
                </Box>
            </Stack>
            {description && <Box sx={styles.description}>{description}</Box>}
        </Stack>
    );
}
